import { render, staticRenderFns } from "./UserMensajeria.vue?vue&type=template&id=38f90e86&scoped=true&"
import script from "./UserMensajeria.vue?vue&type=script&lang=js&"
export * from "./UserMensajeria.vue?vue&type=script&lang=js&"
import style0 from "./UserMensajeria.vue?vue&type=style&index=0&id=38f90e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f90e86",
  null
  
)

export default component.exports